export const getContactSubTypeName = (SubTypeID) => {
    if (SubTypeID === 1) return "Client"
    if (SubTypeID === 2) return "Agency"
    if (SubTypeID === 3) return "Service"
}